module.exports = __webpack_public_path__ + "img/transition_to_dark.8f7fa54.png";